import { getEncodedParams } from 'helpers/encodeParams';

exports.allActivitiesEndpoint = (state, params) => {
    const { start, end } = getEncodedParams(state);
    let tactic = '';
    if (params.tactic) {
        tactic = `&tactic=${params.tactic}`;
    }

    return `${state.config.apiUrl}/v1/entity/${params.entityId}/activities?start=${start}&end=${end}${tactic}`;
};



// WEBPACK FOOTER //
// ./src/services/activities/selectors.js